import React from 'react';
import Image from 'next/image';

import LandingLogoImage from '@/assets/landing/logoImg.png';
import LogoImage from '@/assets/logo.png';

interface LogoProps {
  size?: number;
  className?: string;
  isLanding?: boolean;
  landingUrl?: string;
}
const Logo = ({ size = 130, className, isLanding = false, landingUrl }: LogoProps) => {
  const landingLogo = landingUrl || LandingLogoImage;

  return (
    <Image
      src={isLanding ? landingLogo : LogoImage}
      alt="logo"
      height={size}
      width={size}
      className={className}
    />
  );
};
export default Logo;
